import React, { Component } from 'react';
import NavMenu from './NavMenu';
import withRoot from './withRoot';

export class Layout extends Component {
    constructor(props) {
        super(props);
        document.title = 'Hull College Group';
    }
    render() {
        return (
            <NavMenu mainContent={this.props.children} />
        );
    }
}

export default withRoot(Layout);
